import { getCookies } from "./auth";

export const requestOptions = {
  headers: {
    "content-type": "application/json",
  },
};

export const baseUrl = import.meta.env.VITE_BASE_URL;
